import { Component, Input, OnInit } from '@angular/core';
import { AdminService } from '../services/admin.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-download-csv',
  templateUrl: './download-csv.component.html',
  styleUrls: ['./download-csv.component.scss']
})
export class DownloadCsvComponent implements OnInit {

  @Input() apiEndPoint;
  @Input() filterParams;
  @Input() fileName;
  constructor(private adminService: AdminService) { }

  ngOnInit(): void {
  }

  createCsv(result) {
    let blob = new Blob([result], { type: 'text/csv;charset=utf-8;' });
    let link = document.createElement("a");
    let fileName = `${this.fileName}.csv`;
    if (link.download !== undefined) {         // feature detection
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  downloadCSV() {
    this.adminService.downloadCSV(this.apiEndPoint ,this.filterParams, sessionStorage.getItem("token")).subscribe((response: any) => {
      // console.log("response csv", response)
      this.createCsv(response);
    },
      (error) => {
        console.log(error);
        Swal.fire('Error', `${error.error.message}`, 'error')
      })
  }

}
